<template>
  <div class="story-page">
    <header class="story-head">
      <div class="story-head-inner">
        <div class="sec-eyebrow">我的故事</div>
        <h1 class="story-title">从山西到济南，从前台到技术经理</h1>
        <p class="story-sub">
          十六岁那年靠一颗色子选了济南，兜里揣着两块钱下的火车。
          以下内容整理自我的两篇随笔，完整原文在文末。
        </p>
      </div>
    </header>

    <div class="story-body">
      <section class="chapter" v-for="c in chapters" :key="c.title">
        <div class="ch-period">{{ c.period }}</div>
        <h2 class="ch-title">{{ c.title }}</h2>
        <p v-for="(p, i) in c.paras" :key="i" v-html="p"></p>
        <ul v-if="c.list" class="ch-list">
          <li v-for="item in c.list" :key="item">{{ item }}</li>
        </ul>
        <p v-for="(p, i) in c.parasAfter" :key="'a' + i" v-html="p"></p>
        <pre v-if="c.code" class="ch-code"><code>{{ c.code }}</code></pre>
        <figure v-if="c.photo" class="ch-figure">
          <img :src="c.photo" :alt="c.photoAlt" data-zoom loading="lazy" />
          <figcaption v-if="c.photoNote">{{ c.photoNote }}</figcaption>
        </figure>
      </section>

      <section class="chapter epilogue">
        <div class="ch-period">写在最后</div>
        <blockquote class="ch-quote">
          别羡慕别人的舒服，自己做好自己，不浮躁，稳着点，慢慢进步。
        </blockquote>
      </section>

      <section class="originals">
        <div class="ch-period">原文</div>
        <h2 class="ch-title">两篇随笔的完整版</h2>
        <p class="orig-note">
          上面是节选。完整的原文更长，也更啰嗦一些——那是当时一笔一笔记下来的样子，我没舍得改。
        </p>
        <div class="orig-cards">
          <router-link class="orig-card" to="/articles/1369">
            <span class="orig-name">从酒店前台收银到软件研发教学主管到技术经理之路</span>
            <span class="orig-meta">职业这条线的十年 &rarr;</span>
          </router-link>
          <router-link class="orig-card" to="/articles/1370">
            <span class="orig-name">别羡慕别人的舒服，静下心来坚持奋斗</span>
            <span class="orig-meta">家和心气儿这条线 &rarr;</span>
          </router-link>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "Story",
  data() {
    return {
      chapters: [
        {
          period: "中专",
          title: "从中专开始",
          paras: [
            "当年城里的高中要分数，要分数没分数，平头百姓一个，只能在市里找了个职业中专接着上。入学以来每次考试都是第一，班里的作业都以抄我的为主，那时候有些骄傲。"
          ]
        },
        {
          period: "离家",
          title: "那皱巴巴的一百多块",
          paras: [
            "某个周末回老家拿生活费，家里实在没有钱了。我爸扛了二十五公斤黄豆去镇上卖了一百多块，回来一分没给家里留，全部给了我。接过那皱巴巴的一百多元时，心里很不是滋味，哽咽得快哭出来，但当时没有哭。那一周在学校，状态一直不好。",
            "一周之后我做了一个改变一生的决定：这学不上了。不能因为我一个人上学，耽误老二和老三。"
          ]
        },
        {
          period: "抉择",
          title: "一颗色子，转到了济南",
          paras: [
            "问同学借了一百块，准备出去打工。拿了一颗色子，每个面对应一座城市："
          ],
          list: ["1 —— 太原", "2 —— 石家庄", "3 —— 郑州", "5 —— 兰州", "6 —— 济南"],
          parasAfter: [
            "转到哪里就去哪里。转出来一个六——济南。书包里装了一条毛巾、几本书和洗漱用品，就直奔火车站。九十八块买了火车票，十一个小时后，兜里剩两块钱，到了这座陌生的城市。"
          ]
        },
        {
          period: "凌晨三点",
          title: "济南站的第一夜",
          paras: [
            "下车是凌晨三点半。农历九月，不算特别冷。在报刊亭花一块钱买了一沓报纸，回到出站口的地下通道铺开，躺下睡了一觉——旁边睡着进城的农民工、刚毕业的大学生、出差的公司职员，大家素不相识，各自找块空地。",
            "天亮起来，沿着火车站附近挨家问要不要人，不给工资也行，管吃管住就可以。大多数店家看我瘦小，十六岁，都婉拒了。上午八点多，车站街一家酒店的经理把我留下了，做前台收银。这份知遇之恩，这辈子都忘不了。"
          ],
          photo: "/imgs/blog/career/fbdd9ffc4fffa0298fabe83722470621.jpg",
          photoAlt: "济南站出站口",
          photoNote: "当年的济南站出站口，很多人都这样铺张报纸过夜（图片来源于网络）"
        },
        {
          period: "前台",
          title: "在前台敲下第一行代码",
          paras: [
            "酒店前台是我第一次长时间接触电脑的地方。渐渐意识到收银不是长久的活，开过淘宝店、代理过网络电话、炒过外汇亏了一千多，都不成。直到某天在前台浏览网页，发现了程序员这个职业，一发不可收拾。",
            "买来几本 Java 基础的书，用开淘宝店时的旧电脑，断断续续配了两三天 JDK，在记事本里敲下了人生第一段代码——类名都是中文的："
          ],
          code:
            'public class 穆雄雄 {\n    public static void main(String[] args) {\n        System.out.println("Hello Word");\n    }\n}',
          photo: "/imgs/blog/career/38c12d6408c14e27d101a3338a0457c6.jpg",
          photoAlt: "当年工作的酒店前台"
        },
        {
          period: "半工半读",
          title: "白天上学，晚上值夜班",
          paras: [
            "培训学费要好几万，家里支持不了多少。于是找了份只上夜班的前台工作：下午六点上班到第二天早上八点，下班蹬二十五分钟自行车去上课，下午五点半放学，路边买个一块钱的火烧，再蹬回酒店接着上班。书包里常年背着一把扳手——那辆破自行车的脚蹬子总往下掉，掉了就敲上去。",
            "别的同学晚上在宿舍打游戏，我在前台值班不能打游戏，只能搬出电脑看代码、写代码。每天做完作业，还会把第二天要学的内容提前运行一遍，深怕跟不上。近三个月没有一天早于凌晨一点睡觉。就这样，硬生生把几万块学费从夜班里挣了出来。"
          ],
          photo: "/imgs/blog/career/c12971cf6c91f292751705758c9b68a3.jpg",
          photoAlt: "半工半读时期"
        },
        {
          period: "校园",
          title: "项目组长与全校冠军",
          paras: [
            "从第一学期起一直担任项目组长。IT 精英大赛上，带六个人的团队做了一套加入人脸识别和语音播报的 OA 管理系统，拿了全校冠军，平均分比第二名高出五分多。结业项目的酒店管理系统里做了智能助手、身份证识别回填、定时调度这些当时看来很超纲的功能，评委老师都很惊讶。",
            "班里所有同学的 bug 我都帮着解决过——正是这些「多管闲事」，把技术能力磨了出来。毕业时，学校把我留下了。"
          ]
        },
        {
          period: "讲台",
          title: "教了五年计算机",
          paras: [
            "留校任教五年，前端从 HTML、CSS 讲到 JavaScript 和 Vue，后端讲 Java、JSP、SSM，也带 C# 和数据库。开了公众号记录学生的在校点滴，给作业优秀的学生发小奖章，把早读从只背单词改成隔天读古诗和《弟子规》。连续两年优秀员工，任教第三年被提拔为教学主管，管整个校区的教学质量、课程体系与教材物资，还去武汉参加了全国教学交流分享会，回来给全校老师做分享。",
            "当了老师，夜班也没停——白天在讲台上讲课，晚上照旧回酒店值夜班。后来酒店老板开了羊汤馆，周六日和晚间我就过去帮忙：打羊汤、打包外卖、烤烧饼，酒店那边也照常干。站过讲台，也端过汤碗。"
          ],
          photo: "/imgs/blog/career/5a2fedf15d65a4397271ef58b6532503.jpg",
          photoAlt: "教学场景"
        },
        {
          period: "现在",
          title: "技术经理",
          paras: [
            "教了五年课之后离开学校，进公司做技术。从两个人的小项目起步，一个控件一个控件地查文档，靠加班赶进度；后来带团队交付了全国性填报平台、医院系统和各地的医保项目，技术栈从基于若依的 Spring Boot + Vue 到 mybatis-plus + Avue，都是在项目里一点点磨出来的。",
            "现在团队已经有好几名成员，拿不准的方案，大家把椅子转过来一起讨论。我相信这个团队，不管现在还是未来，都会是一个非常出色的团队。"
          ]
        },
        {
          period: "家",
          title: "挂在洗衣机旁边的手机",
          paras: [
            "给家里打电话通常在晚上十一点之后——家里知道我忙，我也知道他们那个点才忙完牛羊鸡狗那些活。每次通话没有低于一个小时的。老家在山里，我妈的手机只有挂在洗衣机旁边才有信号，接电话要把头凑上去，手机一动就断。后来我买了个信号增强器，信号是强了，一刮风又不行了。",
            "有天二十三点一刻打过去，他们还在吃晚饭。小牛犊下午卡在一个废弃的洞里，全家找到晚上九点才弄出来。电话里依旧嘘寒问暖，聊着聊着，那边没信号了，强制挂断。"
          ]
        }
      ]
    };
  },
  metaInfo: {
    title: "我的故事 - 穆雄雄",
    meta: [
      {
        name: "description",
        content:
          "穆雄雄的故事：十六岁靠一颗色子选了济南，兜里两块钱下火车，从酒店前台收银到半工半读学编程，教了五年计算机，现在是技术经理。"
      }
    ]
  }
};
</script>

<style scoped>
.story-page {
  background: var(--bg);
}
.story-head {
  padding: 108px 24px 56px;
  border-bottom: 1px solid var(--border-soft);
}
.story-head-inner {
  max-width: 720px;
  margin: 0 auto;
}
.story-title {
  font-size: 40px;
  line-height: 1.3;
  font-weight: 600;
  letter-spacing: -1px;
  color: var(--ink);
  margin: 0 0 18px;
}
.story-sub {
  font-size: 15.5px;
  line-height: 2;
  color: var(--ink-soft);
  margin: 0;
}
.story-body {
  max-width: 720px;
  margin: 0 auto;
  padding: 24px 24px 96px;
}
.chapter {
  padding: 44px 0 8px;
  border-bottom: 1px solid var(--border-soft);
}
.ch-period {
  font-size: 13px;
  letter-spacing: 2px;
  color: var(--accent);
  margin-bottom: 10px;
}
.ch-title {
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.4px;
  color: var(--ink);
  margin: 0 0 16px;
}
.chapter p {
  font-size: 15.5px;
  line-height: 2.05;
  color: var(--ink-mid);
  margin: 0 0 16px;
}
.ch-list {
  margin: 0 0 16px;
  padding-left: 22px;
}
.ch-list li {
  font-size: 15px;
  line-height: 2;
  color: var(--ink-mid);
}
/* 全局 markdown 样式会给 code 加白底红字，这里压掉 */
.ch-code code {
  background: transparent;
  color: inherit;
  padding: 0;
  font-size: inherit;
}
.ch-code {
  background: #1f1e1b;
  color: #e8e6df;
  border-radius: var(--radius-sm);
  padding: 18px 20px;
  font-size: 13.5px;
  line-height: 1.8;
  overflow-x: auto;
  margin: 0 0 18px;
}
.ch-figure {
  margin: 6px 0 22px;
}
.ch-figure img {
  width: 100%;
  border-radius: var(--radius);
  border: 1px solid var(--border);
  cursor: zoom-in;
  display: block;
}
.ch-figure figcaption {
  margin-top: 8px;
  font-size: 13px;
  color: var(--ink-faint);
}
.epilogue {
  border-bottom: none;
}
.ch-quote {
  margin: 0;
  padding: 26px 30px;
  background: var(--bg-alt);
  border-left: 3px solid var(--accent);
  border-radius: 0 var(--radius) var(--radius) 0;
  font-size: 18px;
  line-height: 1.9;
  color: var(--ink);
  font-weight: 500;
}
.originals {
  padding-top: 56px;
}
.orig-note {
  font-size: 15px;
  line-height: 2;
  color: var(--ink-soft);
  margin: 0 0 22px;
}
.orig-cards {
  display: grid;
  gap: 14px;
}
.orig-card {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 16px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 20px 24px;
  transition: all 0.2s;
}
.orig-card:hover {
  border-color: var(--accent);
  box-shadow: 0 4px 16px rgba(20, 20, 19, 0.06);
}
.orig-name {
  font-size: 15.5px;
  font-weight: 600;
  color: var(--ink);
  line-height: 1.6;
}
.orig-meta {
  flex-shrink: 0;
  font-size: 13.5px;
  color: var(--accent);
  white-space: nowrap;
}
@media (max-width: 760px) {
  .story-head {
    padding: 76px 20px 40px;
  }
  .story-title {
    font-size: 28px;
  }
  .orig-card {
    flex-direction: column;
    gap: 6px;
  }
}
</style>
